import { CreditPackageType, PackageFaqType } from '~/types/packagesType';
import { appApi } from '~/redux/api/appApiSlice';

export const packagesApiSlice = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getPackages: builder.query<CreditPackageType[], { locale: string }>({
      query: ({ locale }) => {
        return {
          url: '/api/credit/packages',
          headers: {
            'Accept-Language': locale,
          },
        };
      },
      providesTags: ['packages'],
    }),
    getPackageDetails: builder.query<
      CreditPackageType,
      { id: string | undefined; locale: string }
    >({
      query: ({ id, locale }) => {
        return {
          url: `/api/credit/packages/${id}`,
          headers: {
            'Accept-Language': locale,
          },
        };
      },
      providesTags: ['packages'],
    }),
    getPackagesFaqs: builder.query<PackageFaqType[], { locale: string }>({
      query: ({ locale }) => {
        return {
          url: '/api/credit/faqs',
          headers: {
            'Accept-Language': locale,
          },
        };
      },
      providesTags: ['packages'],
    }),
  }),
});

export const {
  useGetPackagesQuery,
  useGetPackageDetailsQuery,
  useGetPackagesFaqsQuery,
} = packagesApiSlice;
